import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { FC } from 'react';

interface InstallAppDialogProps {
  open: boolean;
  isIOS: boolean;
  onInstall: () => Promise<void>;
  onClose: () => void;
}

const InstallAppDialog: FC<InstallAppDialogProps> = ({
  open,
  isIOS,
  onInstall,
  onClose,
}) => {
  const handleInstall = async () => {
    try {
      await onInstall();
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Adicionar à tela inicial</DialogTitle>
      <DialogContent>
        {isIOS ? (
          <List dense disablePadding>
            <ListItem disableGutters>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <IosShareIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary="Toque em Compartilhar"
                secondary="Botão na barra inferior do Safari"
              />
            </ListItem>
            <ListItem disableGutters>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <AddBoxIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary='Role e toque em "Adicionar à Tela de Início"' />
            </ListItem>
            <ListItem disableGutters>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <PhoneIphoneIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary='Toque em "Adicionar" para confirmar' />
            </ListItem>
          </List>
        ) : (
          <ListItemText
            primary="Instale o Agenda7 no seu celular"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {isIOS ? 'Fechar' : 'Agora não'}
        </Button>
        {!isIOS && (
          <Button onClick={handleInstall} variant="contained">
            Instalar
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default InstallAppDialog;
